<template>
  <div class="devOps_producerSpaceSet">
    <el-form ref="form" class="form_warp" inline size="mini" :model="form" label-width="100px" style="margin-top: 10px;">
      <el-form-item label="体系中文名">
        <el-input :style="iptStyle" placeholder="请输入"  v-model="form.nameZh" />
      </el-form-item>
      <el-form-item label="体系英文名">
        <el-input :style="iptStyle" placeholder="请输入"  v-model="form.nameEn" />
      </el-form-item>
      <el-form-item>
        <el-button  style="margin-left:32px;letter-spacing: 2px;font-weight: bold;font-size: 12px;" type="primary" @click="formSearch('reset','search')" v-if="menu.btn_project_system_query">查询
        </el-button>
        <el-button  style="margin-left:32px;letter-spacing: 2px;font-weight: bold;font-size: 12px;" type="primary" @click="showDialogVisible('createSystem')" v-if="menu.btn_project_system_add">新增体系
        </el-button>
      </el-form-item>
    </el-form>
    <div style="height: 70vh">
      <el-table height="100%" :header-cell-style="getCellClass" row-key="id" ref="multipleTable" style="margin-top:0;" :cell-style="getRowClass" :data="tableData">
        <el-table-column prop="username" label="编码">
          <template slot-scope="scope">
            {{scope.row.id }}
          </template>
        </el-table-column>
        <el-table-column prop="name_zh" label="体系名称">
        </el-table-column>
        <el-table-column prop="name_en" label="体系简称">
        </el-table-column>
        <el-table-column prop="statusDesc" label="状态">
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间">
        </el-table-column>
        <el-table-column
            label="操作">
          <template slot-scope="scope">
            <div style="display: flex;">
              <el-button type="primary" round size="mini" @click="showDialogVisible('createSystem', scope.row,true)" v-if="menu.btn_project_system_detail">查看</el-button>
              <el-button type="warning" round size="mini" @click="showDialogVisible('createSystem', scope.row)" v-if="menu.btn_project_system_edit">编辑</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="block devOpsSpace_page">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="[10, 25, 50, 100]"
                     layout="total, prev, pager, next, sizes" :total="total">
      </el-pagination>
    </div>
    <createSystem  v-if="dialogVisible.createSystem" :dialogVisible='dialogVisible.createSystem' :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" :isEdit="isEdit"></createSystem>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {getDevOpsSpaceSystemListApi} from "@/server/tops/devOps";
import createSystem from '@/views/tops/devOps/settingSpace/components/system/createSystem.vue'
import {getDevOpsSpaceMenuListListApi} from "@/server/tops/base";
export default {
  components: {createSystem },
  data() {
    return {
      tableData: [],
      searchData: [],
      form:{
        user:'',
      },
      dialogVisible:{
        createSystem: false,
      },
      checkedInfo:{},
      currentPage: 1,
      pageSize:10,
      total:0,
      // input 搜索样式
      iptStyle: {
        width: '180px'
      },
      isEdit: true,
      menu:{},
    }
  },
  async created() {
    await this.getAuth();
    await this.getNewData();
  },
  computed: {
    ...mapState(
        {
          allSelect: (state) => state.devOps.ALLSELECT,
          allMenuList: (state) => state.devOps.ALLMENULIST,
        }
    ),
  },
  methods: {
    getCellClass(row, column, rowIndex, columnIndex) {
      return "padding: 4px 0;height:36px;background:#7F7F7F;color:#fff;font-size:14px;"
    },
    // 表格样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if(columnIndex == 0 || columnIndex == 1){
        return "border:none;border-top:1px solid #EBEEF5;font-size: 12px;font-weight: bold;padding:6px 0;";
      }
      return "border:none;border-top:1px solid #EBEEF5;font-size: 12px;padding:6px 0;";
    },
    async getNewData(){
      let params = {}
      params.pageNo = this.currentPage
      params.pageSize = this.pageSize
      params.nameZh = this.form.nameZh;
      params.nameEn = this.form.nameEn;
      getDevOpsSpaceSystemListApi(params).then((res)=>{
        this.tableData = res.data;
        this.total = res.count;
      })
    },
    // 弹出模板
    async showDialogVisible(type, row = {},isLook = false) {
      if(isLook){
        this.isEdit = false;
      }else{
        this.isEdit = true;
      }
      this.dialogVisible[type] = true;
      this.checkedInfo = row;
    },
    async hideDialogVisible(nextStep = '', search = true) {
      for (let key in this.dialogVisible) {
        this.dialogVisible[key] = false;
      }
      await this.getNewData();
    },
    formSearch(){
      let newTableData = [];
      this.currentPage = 1;
      this.getNewData();
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1;
      this.getNewData();
    },
    handleCurrentChange(val) {
      this.getNewData();
      //this.currentPage = val
    },
    async getAuth() {
      let menu = {}
      await getDevOpsSpaceMenuListListApi().then((res) => {
        res.data.btnList.forEach((item) => {
            menu[item.code] = 1;
        })
      })
      this.menu = menu;
    },
  }
}
</script>
<style lang="scss">
.devOps_producerSpaceSet{
  .devOpsSpace_page {
    // text-align: right;
    display: flex;
    justify-content: flex-end;
    margin-right: 20px;

    .demonstration {
      font-size: 13px;
      color: #606266;
      line-height: 1;
      margin-top: 25px;
      margin-right: 10px;
    }
  }
  .el-form-item__label {
    font-weight: bold;
    font-size: 12px;
  }
}
.el-message-box__wrapper {
  bottom: initial !important;
  top:10%;
}
</style>
